import { GET_REPORT_DATA } from './mutation-types'
import relatorioFilaDetalhadoHttpService from '../_services/relatorioFilaDetalhadoHttpService'

export default {
  gerarRelatorio: async ({ commit }, form) => {
    try {
      const response = await relatorioFilaDetalhadoHttpService.getCalls(form)
      commit(GET_REPORT_DATA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
